import React, { Fragment } from "react";
import A5Img from "../../assets/svg/a5-logo.svg";
import facebook from "../../assets/img/icon-face.png";
import seta from "../../assets/img/seta.png";
import instagram from "../../assets/img/icon-instagram.png";
import userLogin from "../../assets/img/userlogin.png";
import "./header.css";
import iconMenu from "../../assets/img/menu-icon.png";
import ScrollTo from "../../helpers/scroll";
import SideMenu from "../SideMenu";
import { throttle, debounce } from "throttle-debounce";

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.history.location.state !== undefined) {
      const { componentId } = this.props.history.location.state;
      if (componentId) {
        setTimeout(() => ScrollTo(componentId), 1000);
      }
    }
    this.state = {
      isOpenMenu: false,
      isLoading: true,
      isHeaderFixed: false
    };
    this.handlerLinkto = this.handlerLinkto.bind(this);
    this.handlerLinktoPage = this.handlerLinktoPage.bind(this);
    this.handlerScrollInitialComponent = this.handlerScrollInitialComponent.bind(
      this
    );
    this.handleScroll = this.handleScroll.bind(this);
  }

  async componentDidMount() {
    await window.addEventListener("scroll", this.handleScroll);
  }

  async handleScroll() {
    let top = window.pageYOffset || document.documentElement.scrollTop;
    let header = document.querySelector("Header");
    if (top - 50 > header.offsetHeight) {
      await this.setState({ isHeaderFixed: true, isOpenMenu: false });
    } else {
      await this.setState({ isHeaderFixed: false, isOpenMenu: false });
    }
  }
  async handleLinkSideMenu(componentId) {
    await this.setState({ isOpenMenu: !this.state.isOpenMenu });
    await this.handlerLinkto(componentId);
  }
  handlerLinkto(componentId) {
    this.setState({ isLoading: true });
    const pathName = this.props.history.location.pathname;
    if (pathName !== "/") {
      this.props.history.push(``, { componentId });
    } else {
      ScrollTo(componentId);
    }
  }
  handlerLinktoPage(pathPage) {
    this.props.history.push(`/${pathPage}`);
  }
  handlerScrollInitialComponent() {
    let pathName = this.props.history.location.pathname;

    pathName = pathName.replace("/", "");

    if (pathName === "CadastrarLivro") {
      ScrollTo("BookRegister");
    } else if (pathName.includes("Livro")) {
      ScrollTo("BookDetails");
      return;
    } else if (pathName.includes("Loja")) {
      ScrollTo("OurBooks");
      return;
    }

    let idComponent = "";

    switch (pathName) {
      case "":
        idComponent = "PublishingCompany";
        break;
      case "NewBooks":
        idComponent = "NewBooks";
        break;
      case "CadastrarAutor":
        idComponent = "AuthorRegister";
        break;
      case "CadastrarLivro":
        idComponent = "BookRegister";
        break;
      case "CadastrarLivro":
        idComponent = "BookRegister";
        break;
      default:
        idComponent = null;
        break;
    }
    ScrollTo(idComponent);
  }

  render() {
    const { isHeaderFixed } = this.state;
    return (
      <Fragment>
        <SideMenu isOpen={this.state.isOpenMenu}>
          <ul>
            <li
              onClick={() => this.handleLinkSideMenu("Header")}
              className="sidemenu-list-item"
            >
              HOME
            </li>
            <li
              onClick={() => this.handleLinkSideMenu("PublishingCompany")}
              className="sidemenu-list-item"
            >
              A EDITORA
            </li>
            <li
              onClick={() => this.handleLinkSideMenu("Authors")}
              className="sidemenu-list-item"
            >
              AUTORES
            </li>
            <li
              onClick={() => this.handleLinkSideMenu("newBooks")}
              className="sidemenu-list-item"
            >
              LIVROS
            </li>
            <li
              onClick={() => this.handleLinkSideMenu("Publish")}
              className="sidemenu-list-item"
            >
              PUBLIQUE
            </li>
            <li
              onClick={() => this.handleLinkSideMenu("Contact")}
              className="sidemenu-list-item"
            >
              CONTATO
            </li>
          </ul>
        </SideMenu>
        <header
          id="Header"
          style={
            this.props.children ? { minHeight: "100%", height: "auto" } : {}
          }
          className="header"
        >
          <div
            className={` header__menuresponsivo ${
              isHeaderFixed ? "header__menuresponsivo--fixed" : ""
              }`}
          >
            <div className="header__menuresponsivo__content">
              <button
                onClick={async (e) => {
                  await this.setState({ isOpenMenu: !this.state.isOpenMenu })
                }}
                className="header__menuresponsivo__content__button"
              >
                <img
                  className="header__menuresponsivo__content__iconmenu"
                  src={iconMenu}
                  alt="menu-icon"
                />
              </button>
              <h4 className="header__menuresponsivo__content__title">MENU</h4>
            </div>
            <div className="header__menuresponsivo__content">
              <figure>
                <a target="blank" href="https://facebook.com/a5editora">
                  <img
                    className="header__menuresponsivo__content__redesociais"
                    src={facebook}
                    alt=""
                  />
                </a>
                <a
                  target="blank"
                  href="https://instagram.com/a5editora?utm_source=ig_profile_share&igshid=uv77n98kxjaf"
                >
                  <img
                    className="header__menuresponsivo__content__redesociais"
                    src={instagram}
                    alt=""
                  />
                </a>
              </figure>
            </div>
          </div>
          <div
            className={` ${isHeaderFixed ? "header__logocontent--fixed" : ""}`}
          >
            <div
              className={` container ${
                isHeaderFixed ? "header__logocontent--fixed__content" : ""
                }`}
            >
              <div className="header__logocontent">
                <div className="header__logocontent_redesociais">
                  <a target="blank" href="https://facebook.com/a5editora">
                    <img className="" src={facebook} alt="" />
                  </a>
                  <a
                    target="blank"
                    href="https://instagram.com/a5editora?utm_source=ig_profile_share&igshid=uv77n98kxjaf"
                  >
                    <img className="" src={instagram} alt="" />
                  </a>
                </div>
                <div className="header__logocontent__logo animated bounceInDown">
                  <img src={A5Img} alt="" />
                </div>
                <div className="header__logocontent__acesso">
                  {
                    /*
                    code para ativar login/ cadastro no header
                    <div className="header__logocontent__acesso__buttons">
                      <button className="header__logocontent__acesso__buttons__button">
                        Entrar
                      </button>
                      <button className="header__logocontent__acesso__buttons__button">
                        Cadastrar
                      </button>
                    </div>
                    <img
                      className="header__logocontent__acesso__userlogin"
                      src={userLogin}
                      alt="userLogin"
                    />
                     */
                  }
                </div>
              </div>
              <nav className="header__menu">
                <ul>
                  <li onClick={() => this.handlerLinkto("Header")}> HOME </li>
                  <li onClick={() => this.handlerLinkto("PublishingCompany")}>
                    {" "}
                    A EDITORA{" "}
                  </li>
                  <li onClick={() => this.handlerLinkto("Authors")}>
                    {" "}
                    AUTORES{" "}
                  </li>
                  <li onClick={() => this.handlerLinkto("newBooks")}>
                    {" "}
                    LIVROS{" "}
                  </li>
                  <li onClick={() => this.handlerLinkto("Publish")}>
                    {" "}
                    PUBLIQUE{" "}
                  </li>
                  <li onClick={() => this.handlerLinkto("Contact")}>
                    {" "}
                    CONTATO{" "}
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          {this.props.children ? (
            this.props.children
          ) : (
              <div className="header__content">
                <div className="header__content__titles">
                  <h1 className="animated bounceInLeft">DO PAPEL AO DIGITAL</h1>
                  <h2 className="animated bounceInRight">
                    Os melhores <span> Livros </span>{" "}
                  </h2>
                </div>
                <button
                  className="header__content__publish"
                  onClick={() => this.handlerLinkto("Publish")}
                >
                  QUERO PUBLICAR
              </button>
                <button
                  className="header__content__arrow"
                  onClick={() => this.handlerScrollInitialComponent()}
                >
                  <img src={seta} alt="icon-flecha" />
                </button>
              </div>
            )}
        </header>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js